import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InViewportModule } from 'ng-in-viewport';
import { NgxGlideModule } from 'ngx-glide';
import { SharedModule } from '../shared/shared.module';
import { ReferralPageV2RoutingModule } from './referral-page-v2-routing.module';
import { TruecallerPopupModule } from '../common/truecaller-popup/truecaller-popup.module';

import {
  ReferralMainComponent, MonthlyStaticSpriteComponent, ReferralSuccessStoriesComponent
} from './components';
import { SipTickerModule } from '../common/sip-ticker/sip-ticker.module';
import { TalkToUsBtnModule } from '../common/talk-to-us-btn/talk-to-us-btn.module';
import { BannerComponent } from './components/banner/banner.component';
import { DmSelectLivesModule } from '../common/dm-select-lives/dm-select-lives.module';
import { RewardsAndBenefitsModule } from '../common/rewards-and-benefits/rewards-and-benefits.module';
import { ChatWithUsModule } from '../common/chat-with-us/chat-with-us.module';
import { FaqsModule } from '../common/faqs/faqs.module';
import { ImpactDockerModule } from '../common/impact-docker/impact-docker.module';
import { InputModule } from '../common/input/input.module';
import { IntlInputModule } from '../common/intl-input/intl-input.module';
import { MonthlyGivingProgramModule } from '../common/monthly-giving-program/monthly-giving-program.module';
import { OfferTagModule } from '../common/offer-tag/offer-tag.module';
import { OfferModule } from '../common/offer/offer.module';
import { PaymentSipModule } from '../common/payment-sip/payment-sip.module';
import { PortfolioMobileFooterModule } from '../common/portfolio-mobile-footer/portfolio-mobile-footer.module';
import { ReferralHeaderModule } from '../common/referral-header/referral-header.module';
import { ReferralHowItWorksModule } from '../common/referral-how-it-works/referral-how-it-works.module';
import { SipImpactModule } from '../common/sip-impact/sip-impact.module';
import { SipStaticWhoAreWeModule } from '../common/sip-static-who-are-we/sip-static-who-are-we.module';
import { SocialStripModule } from '../common/social-strip/social-strip.module';
import { StaticSuccessStoriesModule } from '../common/static-success-stories/static-success-stories.module';
import { StickyHeaderModule } from '../common/sticky-header/sticky-header.module';
import { TyMonthlyGivingProgramModule } from '../common/ty-monthly-giving-program/ty-monthly-giving-program.module';
import { TyTestimonialsModule } from '../common/ty-testimonials/ty-testimonials.module';
import { MatButtonModule } from '@angular/material/button';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { VideoDmModule } from '../common/video-dm/video-dm.module';

@NgModule({
  declarations: [
    ReferralMainComponent,
    MonthlyStaticSpriteComponent,
    ReferralSuccessStoriesComponent,
    BannerComponent
  ],
  imports: [
    CommonModule,
    ReferralPageV2RoutingModule,
    MonthlyGivingProgramModule,
    TyTestimonialsModule,
    FaqsModule,
    ChatWithUsModule,
    TyMonthlyGivingProgramModule,
    StaticSuccessStoriesModule,
    PortfolioMobileFooterModule,
    SharedModule,
    ImpactDockerModule,
    InputModule,
    IntlInputModule,
    NgxGlideModule,
    SipImpactModule,
    SipStaticWhoAreWeModule,
    ReferralHowItWorksModule,
    InViewportModule,
    SocialStripModule,
    StickyHeaderModule,
    OfferModule,
    ReferralHeaderModule,
    TruecallerPopupModule,
    PaymentSipModule,
    OfferTagModule,
    SipTickerModule,
    TalkToUsBtnModule,
    DmSelectLivesModule,
    RewardsAndBenefitsModule,
    MatButtonModule,
    ModuleLoaderModule,
    VideoDmModule
  ],
  exports: [ReferralMainComponent],
  bootstrap: [ReferralMainComponent],
})
export class ReferralPageV2Module {
  getComponent() {
    return ReferralMainComponent;
  }
}
